export enum PolicyPageTitles {
  POLICIES_LANDING_ACTIVE = 'Current Policies',
  POLICIES_LANDING_ARCHIVED = 'Archived Policies',
  POLICY_OVERVIEW = 'Overview',
  POLICY_COVERAGES = 'Coverages',
  POLICY_DISCOUNTS = 'Discounts',
  POLICY_ID_CARDS = 'ID Cards',
  EDIT_COVERAGES = 'Edit Coverages',
  ADD_VEHICLE = 'Add Vehicle',
  QUOTE_VEHICLE = 'Quote Vehicle',
  QUOTE_DRIVER = 'Quote Driver',
  REMOVE_VEHICLE = 'Remove a Vehicle',
  REMOVE_LENDER = 'Remove Lender',
  CHANGE_DEDUCTIBLE = 'Change  Deductible',
  UPDATE_LENDER_INFORMATION_NEED = "Information You'll Need",
  UPDATE_LENDER_REPLACE = 'Replace Lender',
  UPDATE_LENDER_BANK_INFO = 'Update Bank Information',
  UPDATE_LENDER_SEARCH = 'Lender Search',
  UPDATE_LENDER_MORTGAGE_DETAILS = 'Mortgage Details',
  UPDATE_LENDER_CONFIRM_CHANGES = 'Confirm Changes',
  QUOTE_AND_ADD_VEHICLE_KNOCKOUT = 'Start a Vehicle Quote',
  QUOTE_AND_ADD_VEHICLE_INTRODUCTION = "Information You'll Need",
  QUOTE_AND_ADD_VEHICLE_SPECIFY_VEHICLE = 'Vehicle Selection',
  QUOTE_AND_ADD_VEHICLE_FIND_VEHICLE = 'Find Your Vehicle',
  QUOTE_AND_ADD_VEHICLE_PURCHASE_DETAILS = 'Purchase Details',
  QUOTE_AND_ADD_VEHICLE_VEHICLE_DETAILS = 'Vehicle Details',
  QUOTE_AND_ADD_VEHICLES_ADDITIONAL_VEHICLE_DETAILS = 'Additional Vehicle Details',
  QUOTE_AND_ADD_VEHICLE_EDIT_COVERAGES = 'Calculate Premium',
  QUOTE_AND_ADD_VEHICLE_LENDER_SEARCH = 'Find Your Financial Company',
  QUOTE_AND_ADD_VEHICLE_REVIEW = 'Review Your Changes',
  ALL_DONE = 'All Done!'
}

export enum ClaimsPageTitles {
  CLAIM_OVERVIEW = 'Claim Overview',
  CLAIM_COVERAGES_PAYMENTS = 'Claim Coverages and Payments',
  CLAIM_DOCUMENTS = 'Claim Documents',
  CLAIM_MESSENGER = 'Claim Messenger',
  CLAIM_NOTIFICATIONS = 'Claim Notifications'
}

export enum AccountPageTitles {
  LOGIN = 'Login or Create Account',
  ACCOUNT_INFORMATION = 'Account Information',
  ACCOUNT_VERIFICATION = 'Account Verification',
  ACCOUNT_VALIDATION = 'Account Validation',
  LOGIN_ID = 'Login ID Primary Email',
  PASSWORD = 'Password',
  ACCOUNT_CREATED = 'Account Created',
  RESET_PASSWORD = 'Reset Your Password'
}

export enum MainNavigationPageTitles {
  ACCOUNT = 'Account',
  BILLING = 'Billing',
  POLICIES = 'Policies',
  CLAIMS = 'Open and Closed Claims',
  DOCUMENTS = 'Documents',
  PROFILE = 'Profile'
}

export enum ProfilePageTitles {
  CONTACT_INFO = 'Contact Information',
  SECURITY = 'Security',
  PAPERLESS = 'Paperless',
  EDIT_EBill = 'E-Bill',
  EDIT_EPolicy = 'E-Policy',
  EDIT_LIFE_E_DOC = 'Life E-Documents',
  NOTIFICATIONS = 'Notifications',
  PHONE_NUMBER = 'Phone Number',
  EPROXY = 'E-Proxy',
  EMAIL = 'Email',
  ADD_A_NEW_EMAIL = 'Add a New Email',
  PHONE = 'Phone',
  ADD_A_NEW_PHONE = 'Add a New Phone',
  ADDRESS = 'Address',
  PASSWORD = 'Password',
  MULTIFACTOR_AUTHENTICATION = 'Multi-Factor Authentication'
}

export enum QuotingPageTitles {
  ABOUT_YOU = 'About You',
  ADDRESS_INFO = 'Address Info',
  DRIVER = 'Driver Info',
  RIDER = 'Rider Info',
  VEHICLE = 'Vehicle Info',
  PROPERTY = 'Property Info',
  DRIVING_HISTORY = 'Driving History',
  HOME_HISTORY = 'Home History',
  INSURANCE_INFO = 'Insurance Info',
  DISCOUNTS = 'Discounts',
  SUMMARY = 'Quote Summary',
  LOADING = 'Loading',
  ERROR = 'Error'
}

export enum BindPageTitles {
  ADDITIONAL_INFORMATION = 'Additional Information',
  FINALIZE_POLICY_OWNERS = 'Finalize Policy Owners',
  FINALIZE_DRIVERS = 'Finalize Drivers',
  FINALIZE_VEHICLES = 'Finalize Vehicles',
  FINALIZE_RENTERS = 'Finalize Renters',
  FINALIZE_HOMEOWNERS = 'Finalize Homeowners',
  FINALIZE_MORTGAGE_INFO = 'Mortgage Info',
  FINAL_QUOTE = 'Final Quote',
  PREMIUM_CHANGE = 'Premium Change'
}

export enum BillingPageTitles {
  OVERVIEW = 'Billing Overview',
  MAKE_A_PAYMENT = 'Make a Payment',
  AUTO_PAY = 'Auto Pay',
  PAYMENT_METHODS = 'Payment Methods',
  TRANSACTIONS = 'Transactions'
}

export enum PayAsGuestPageTitles {
  SELECT_POLICY = 'Select Policy',
  FIND_BILL = 'Find Your Bill',
  PAYMENT_AMOUNT = 'Payment Amount',
  CONTACT_INFO = 'Contact Information',
  MAKE_PAYMENT = 'Make a Payment',
  CONFIRMATION = 'Payment Confirmation'
}

export enum FNOLPageTitles {
  REPORT_A_CLAIM_PRELOGIN = 'Report a Claim without Login',
  REPORT_A_CLAIM = 'Report a Claim',
  SELECT_POLICY = 'Which are You Filing a Claim On?',
  WHAT_TYPE_OF_CLAIM_ARE_YOU_FILING = 'What Type of Claim are You Filing?',
  WHO_IS_FILING_THE_CLAIM = 'Who is Filing the Claim?',
  POLICY_DETAILS = 'Policy Details',
  WHAT_HAPPENED_TO_THE_VEHICLE = 'What Happened to the Vehicle?',
  WHAT_HAPPENED_TO_THE_VESSEL = 'What Happened to the Vessel?',
  HAS_VEHICLE_BEEN_RECOVERED = 'Has the Vehicle Been Recovered?',
  TOW_COST = 'How Much Did the Tow Cost?',
  HOW_DID_IT_HAPPEN = 'How Did it Happen?',
  SAFELITE_GLASS = 'Complete Your Glass Claim with Safelite',
  WHERES_THE_GLASS_DAMAGE_LOCATED = "Where's the Glass Damage Located?",
  WAS_YOUR_VEHICLE_DAMAGED = 'Was Your Vehicle Damaged?',
  WHERE_IS_THE_VEHICLE = 'Do You Know Where the Vehicle is Now?',
  WHO_WAS_DRIVING = 'Who was Driving?',
  WHO_OWNS_THE_VEHICLE = 'Who Owns the Vehicle?',
  WHO_OWNS_THE_VESSEL = 'Who Owns the Vessel?',
  WAS_ANYONE_INJURED = 'Was Anyone Injured?',
  DESCRIBE_WHAT_HAPPENED = 'What Best Describes What Happened?',
  WAS_WEATHER_REALTED = 'Was the Damage Weather Related?',
  CAUSE_OF_DAMAGE = 'What Caused the Damage?',
  NATUER_OF_DISABILITY = 'What is the Nature of Your Disability?',
  CAUSE_OF_DEATH = 'What was the Cause of Death?',
  WHERE_DID_INCIDENT_OCCUR = 'Where Did the Incident Occur?',
  WHEN_DID_INCIDENT_OCCUR = 'When Did the Incident Occur?',
  WHAT_HAPPENED = 'What Happened?',
  LETS_GATHER_SOME_MORE_DETAILS = "Let's Gather Some More Details",
  WHO_IS_REPORTING_THE_CLAIM = 'Who is Reporting the Claim?',
  RECIEVE_TEXT_NOTIFICATIONS = 'Would You Like to Receive Text Notifications?',
  CONTACT_INFO = 'Contact Information',
  LETS_DOUBLE_CHECK = "Let's Double-check Everything",
  DONE = "You're Done!"
}

export enum DocumentsPageTitles {
  SEND_FILES = 'Send Files',
  ID_CARDS = 'ID Cards'
}

export enum ExpressIDCardTitles {
  EXPRESS_ID_CARDS = 'Email ID Cards'
}
